import { render } from "./productConfigurationStep.vue?vue&type=template&id=37667e83&scoped=true&ts=true"
import script from "./productConfigurationStep.vue?vue&type=script&lang=ts"
export * from "./productConfigurationStep.vue?vue&type=script&lang=ts"

import "./productConfigurationStep.vue?vue&type=style&index=0&id=37667e83&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37667e83"]])

export default __exports__